export function createBitmask<T extends string>(keys: T[]): Record<T, number> {
  const bitmask: Partial<Record<T, number>> = {};
  keys.forEach((key, index) => {
    bitmask[key] = index === 0 ? 0 : (1 << (index - 1));
  });
  return bitmask as Record<T, number>;
}

export type Bitmask<T> = {[K in keyof T]: T[K]};

export function getKeyFromBitmask<T extends Record<string, number>>(
  bitmask: T,
  value: number
): string | undefined {
  const entries = Object.entries(bitmask);
  const foundEntry = entries.find(([key, entryValue]) => entryValue === value);
  return foundEntry ? foundEntry[0] : undefined;
}

export function getKeysFromBitmask<T extends Record<string, number>>(
  bitmask: T,
  value: number
): string[] {
  const entries = Object.entries(bitmask);
  return entries.filter(([key, entryValue]) => (
    entryValue === value || (entryValue & value) > 0
  )).map(([key, entryValue]) => key);
}
